import { motion } from "framer-motion"
import { Sparkles } from "lucide-react"

export default function CTABanner() {
  return (
    <section className="relative py-20 sm:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-900/20 via-yellow-800/10 to-yellow-900/20" />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black" />

      {/* Decorative */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-600/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-600/40 to-transparent" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mb-6"
            style={{ fontFamily: "'Orbitron', sans-serif" }}
          >
            <span className="text-white">Ready to </span>
            <span className="gold-shimmer">Shine?</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-lg mx-auto mb-10">
            Dive into the most comprehensive collection of luxury gaming cosmetics. Your lobby presence starts here.
          </p>
          <a
            href="#featured-games"
            className="group inline-flex items-center gap-3 px-10 py-5 rounded-xl gold-shimmer-bg text-black font-bold text-lg uppercase tracking-wider transition-all hover:scale-105 hover:shadow-2xl hover:shadow-yellow-500/25"
          >
            Explore the Best Bling Skins
            <Sparkles className="w-5 h-5 group-hover:rotate-12 transition-transform" />
          </a>
        </motion.div>
      </div>
    </section>
  )
}
